"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UseDeleteNotification = UseDeleteNotification;
const react_1 = __importStar(require("react"));
const yup_1 = require("@hookform/resolvers/yup");
const react_2 = require("react");
const react_hook_form_1 = require("react-hook-form");
const sweetalert2_1 = __importDefault(require("sweetalert2"));
const yup = __importStar(require("yup"));
const notification_api_1 = require("../../../../utils/api/notification/notification.api");
const theme_1 = require("../../../../utils/theme");
const Utils_1 = require("../../../../utils/Utils");
const categorie_api_1 = require("../../../../utils/api/categorie/categorie.api");
const hook_1 = require("../../../../redux/hook");
const direction_api_1 = require("../../../../utils/api/direction/direction.api");
const UseCrudNotification = (handleClose, notif) => {
    var _a, _b;
    const [media, setMedia] = (0, react_1.useState)();
    const [mediaType, setMediaType] = (0, react_1.useState)();
    const [description, setDescription] = react_1.default.useState(undefined);
    const [segment, setSegment] = (0, react_1.useState)(null);
    const [direction, setDirection] = (0, react_1.useState)(null);
    const [severity, setSeverity] = (0, react_1.useState)(null);
    const [type, setType] = (0, react_1.useState)("");
    const validationSchema = yup.object().shape({
        hasEdit: yup.boolean(),
        categorie_id: yup
            .string()
            .required("La catégorie est requise.")
            .nullable(),
        segment: yup.string().required("Le segment est requis.").nullable(),
        is_scheduled: yup.mixed().oneOf([0, 1]).nullable(),
        type: yup
            .mixed()
            .required("Le type de notification est requis.")
            .nullable(),
        content: yup
            .string()
            .nullable()
            .when('type', {
            is: 'texte',
            then: (schema) => schema.required("La description est requise."),
            otherwise: (schema) => schema.nullable()
        }),
        //   .when("$categorieType", {
        //     is: "Accident", // ← on vérifie le name de la catégorie ici
        //     then: (schema) => schema.required("La description est requise."),
        //     otherwise: (schema) => schema.nullable(),
        //   }),
        direction_id: yup.string().nullable(),
        //   .required("La direction est requise."),
        //   .when("$categorieType", {
        //     is: "Accident",
        //     then: (schema) => schema.required("La direction est requise."),
        //     otherwise: (schema) => schema.nullable(),
        //   }),
        severity: yup.string().required("La gravité est requise.").nullable(),
        //   .required("La direction est requise."),
        //   .when("$categorieType", {
        //     is: "Accident",
        //     then: (schema) => schema.required("La direction est requise."),
        //     otherwise: (schema) => schema.nullable(),
        //   }),
        media: yup
            .mixed()
            .nullable()
            .when('type', {
            is: (type) => ['audio', 'video', 'image'].includes(type),
            then: (schema) => schema.required("Le média est requis."),
            otherwise: (schema) => schema.nullable()
        }),
        title: yup.string().nullable()
            .when('direction_id', {
            is: (value) => value === 0 || value === '0',
            then: (schema) => schema.required("Le titre est requis."),
            otherwise: (schema) => schema.nullable()
        }),
    });
    const { user } = (0, hook_1.useAppSelector)((state) => state.user);
    const { register, handleSubmit, formState: { errors }, setValue, clearErrors, reset, } = (0, react_hook_form_1.useForm)({
        resolver: (0, yup_1.yupResolver)(validationSchema),
        context: {
            categorieType: type,
        },
        defaultValues: {
            added_by: user.user_id,
            media_type: (notif === null || notif === void 0 ? void 0 : notif.media_type) || "",
            is_scheduled: (notif === null || notif === void 0 ? void 0 : notif.is_scheduled) || 0,
        },
    });
    const [addOrUpdateNotif, { isLoading, isSuccess, error, isError }] = (0, notification_api_1.useAddOrUpdateNotificationMutation)();
    const { data = { data: [], count: 0 }, isLoading: isLoadCategorie } = (0, categorie_api_1.useCategorieByTypeQuery)("notification");
    const { data: severities = { data: [], count: 0 }, isLoading: isLoadSeverities, } = (0, notification_api_1.useGetNotificationsSeveritiesQuery)({});
    const { data: directions = { data: [], count: 0 }, isLoading: isLoadDirection, } = (0, direction_api_1.useGetDirectionsQuery)({});
    const handleChange = (value) => {
        setDescription(value);
        setValue("content", value);
    };
    // const handleSetType = (categorie: any) => {
    //     setType(categorie?.type);
    //     setValue("categorie_id", categorie?.id);
    //   };
    const handleChangeType = (type) => {
        console.log('type', type);
        setType(type);
        setValue("type", type === null || type === void 0 ? void 0 : type.value);
    };
    const segmentOptions = (0, react_1.useMemo)(() => {
        const options = [
            { label: "Tous les utilisateurs", value: "tous" },
            { label: "Collaborateurs (Opérateurs PC, Management & Staff)", value: "collaborateur" },
            { label: "Utilisateurs (Grand public)", value: "utilisateur" },
            { label: "Administrateurs (Admin et SuperAdmin)", value: "admin" },
        ];
        if ((user === null || user === void 0 ? void 0 : user.email) === "sadio.sanghare@volkeno.sn") {
            options.push({
                label: "Test Disponibilité",
                value: "disponibility",
            });
        }
        return options;
    }, [user === null || user === void 0 ? void 0 : user.email]);
    // const segmentOptions = [
    //     {
    //         label: "Tous les utilisateurs",
    //         value: "tous",
    //     },
    //     {
    //         label: "Collaborateurs (Opérateurs PC, Management & Staff)",
    //         value: "collaborateur",
    //     },
    //     {
    //         label: "Utilisateurs (Grand public)",
    //         value: "utilisateur",
    //     },
    //     {
    //         label: "Administrateurs (Admin et SuperAdmin)",
    //         value: "admin",
    //     },
    //     ...(user?.email === "sadio.sanghare@volkeno.sn"
    //         ? [
    //               {
    //                   label: "Test Disponibilité",
    //                   value: "disponibility",
    //               },
    //           ]
    //         : []),
    // ];
    const directionOptions = [
        ...(((_a = directions === null || directions === void 0 ? void 0 : directions.data) === null || _a === void 0 ? void 0 : _a.map((direction, index) => ({
            label: `${direction === null || direction === void 0 ? void 0 : direction.from} - ${direction === null || direction === void 0 ? void 0 : direction.to}`,
            value: direction === null || direction === void 0 ? void 0 : direction.id,
        }))) || []),
        { label: "AUTRE", value: 0 },
    ];
    const severityOptions = ((_b = severities === null || severities === void 0 ? void 0 : severities.data) === null || _b === void 0 ? void 0 : _b.map((severity) => ({
        label: `${severity === null || severity === void 0 ? void 0 : severity.title}`,
        value: severity === null || severity === void 0 ? void 0 : severity.id,
    }))) || [];
    const handleSegmentChange = (segment) => {
        setSegment(segment);
        setValue("segment", segment === null || segment === void 0 ? void 0 : segment.value);
    };
    const handleDirectionChange = (direction) => {
        setDirection(direction);
        setValue("direction_id", direction === null || direction === void 0 ? void 0 : direction.value);
    };
    const handleSeveritieChange = (severity) => {
        setSeverity(severity);
        setValue("severity", severity === null || severity === void 0 ? void 0 : severity.value);
    };
    (0, react_2.useEffect)(() => {
        var _a, _b;
        if (isSuccess) {
            sweetalert2_1.default.fire({
                icon: "success",
                title: `Notification ${notif ? "modifiée" : "ajoutée"} avec succès!`,
                iconColor: theme_1.Color.success,
                showConfirmButton: false,
                timer: 1200,
            }).then(() => {
                if (!notif) {
                    reset();
                    setDescription("");
                    setMedia(null);
                    setMediaType(null);
                    setDirection(null);
                }
                handleClose();
            });
        }
        const err = error;
        if (isError) {
            sweetalert2_1.default.fire({
                icon: "error",
                title: ((_a = err === null || err === void 0 ? void 0 : err.data) === null || _a === void 0 ? void 0 : _a.message)
                    ? (_b = err === null || err === void 0 ? void 0 : err.data) === null || _b === void 0 ? void 0 : _b.message
                    : `Erreur de statut ${err === null || err === void 0 ? void 0 : err.status}`,
                showConfirmButton: false,
                timer: 5000,
            });
        }
    }, [isLoading]);
    (0, react_2.useEffect)(() => {
        (0, Utils_1.cleannerError)(errors, clearErrors);
    }, [errors, clearErrors]);
    const onSubmit = (0, react_1.useCallback)((data) => __awaiter(void 0, void 0, void 0, function* () {
        const fd = new FormData();
        if (data.hasEdit) {
            fd.append("_method", "PUT");
        }
        for (let key of Object.keys(data)) {
            if (key === "media") {
                if (data[key] && data[key] !== undefined) {
                    fd.append(key, data[key]);
                }
            }
            else if (key === "is_scheduled") {
                fd.append(key, Number(data[key]).toString());
            }
            else {
                fd.append(key, data[key]);
            }
        }
        yield addOrUpdateNotif({ id: notif === null || notif === void 0 ? void 0 : notif.id, data: fd });
    }), [notif === null || notif === void 0 ? void 0 : notif.id, addOrUpdateNotif]);
    (0, react_2.useEffect)(() => {
        if (notif === null || notif === void 0 ? void 0 : notif.id) {
            setValue("hasEdit", true);
            let fields = [
                "content",
                "id",
                "media_type",
                "media",
                "categorie_id",
                "type",
                "title",
                "is_scheduled",
                "severity",
                "direction_id",
                "segment",
                "added_by",
            ];
            setMedia(notif === null || notif === void 0 ? void 0 : notif.media);
            setMediaType(notif === null || notif === void 0 ? void 0 : notif.media_type);
            for (let field of fields) {
                register(field);
                setValue(field, notif[field]);
            }
            if (notif === null || notif === void 0 ? void 0 : notif.content) {
                setDescription((notif === null || notif === void 0 ? void 0 : notif.content) || "");
            }
            if (notif === null || notif === void 0 ? void 0 : notif.segment) {
                setSegment((notif === null || notif === void 0 ? void 0 : notif.segment) || "");
            }
            if (notif === null || notif === void 0 ? void 0 : notif.direction_id) {
                setDirection((notif === null || notif === void 0 ? void 0 : notif.direction_id) || "");
            }
            if (notif === null || notif === void 0 ? void 0 : notif.severity) {
                setSeverity((notif === null || notif === void 0 ? void 0 : notif.severity) || "");
            }
            if ((notif === null || notif === void 0 ? void 0 : notif.is_scheduled) === 1 && (notif === null || notif === void 0 ? void 0 : notif.scheduled_datetime)) {
                const localDateTime = new Date(notif === null || notif === void 0 ? void 0 : notif.scheduled_datetime)
                    .toISOString()
                    .slice(0, 16);
                setValue('scheduled_datetime', localDateTime || "");
            }
            if ((notif === null || notif === void 0 ? void 0 : notif.media_type) && (notif === null || notif === void 0 ? void 0 : notif.media_type) !== "null") {
                let type = [{ value: "texte", label: "Texte" },
                    { value: "audio", label: "Audio" },
                    { value: "image", label: "Image" },
                    { value: "video", label: "Vidéo" },
                ].find((option) => option.value === (notif === null || notif === void 0 ? void 0 : notif.media_type));
                setType(type || "");
                setValue('type', type === null || type === void 0 ? void 0 : type.value);
            }
            else {
                setType({ value: "texte", label: "Texte" });
                setValue('type', 'texte');
            }
        }
        else {
            setValue("hasEdit", false);
        }
    }, [notif]);
    (0, react_2.useEffect)(() => {
        if (media === null || media === void 0 ? void 0 : media.name) {
            setValue("media", media);
        }
    }, [media]);
    const handleMediaChange = (file) => {
        if (!file) {
            setMedia(null);
            setMediaType(null);
            setValue("media", null);
            setValue("media_type", null);
            return;
        }
        const detectMediaType = (file) => {
            if (file.type.startsWith("image/"))
                return "image";
            if (file.type.startsWith("video/"))
                return "video";
            if (file.type.startsWith("audio/"))
                return "audio";
            if (file.type === "application/pdf")
                return "pdf";
            return "autre";
        };
        setMedia(file);
        const type = detectMediaType(file);
        setMediaType(type);
        setValue("media", file);
        setValue("media_type", type);
    };
    return {
        register,
        errors: errors,
        onSubmit: handleSubmit(onSubmit),
        setValue,
        isLoading,
        reset,
        description,
        setDescription,
        handleChange,
        media,
        setMedia,
        mediaType,
        setMediaType,
        segmentOptions,
        setSegment,
        segment,
        handleSegmentChange,
        directionOptions,
        setDirection,
        direction,
        handleDirectionChange,
        severityOptions,
        setSeverity,
        severity,
        handleSeveritieChange,
        categories: data === null || data === void 0 ? void 0 : data.data,
        handleMediaChange,
        type,
        setType,
        handleChangeType,
    };
};
exports.default = UseCrudNotification;
function UseDeleteNotification(id) {
    const [deleteData] = (0, notification_api_1.useDeleteNotificationMutation)();
    const onDelete = () => __awaiter(this, void 0, void 0, function* () {
        yield sweetalert2_1.default.fire({
            title: `Êtes-vous sûr de vouloir supprimer cette notification ?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "OUI",
            cancelButtonText: "NON",
            showLoaderOnConfirm: true,
            iconColor: theme_1.Color.themeColor,
            confirmButtonColor: theme_1.Color.themeColor,
            preConfirm: () => {
                return deleteData(id);
            },
            allowOutsideClick: () => !sweetalert2_1.default.isLoading(),
        }).then((result) => {
            if (result === null || result === void 0 ? void 0 : result.value) {
                sweetalert2_1.default.fire({
                    icon: "success",
                    title: `Notification supprimée avec succès!`,
                    iconColor: theme_1.Color.themeColor,
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        });
    });
    return onDelete;
}
